import {FC, memo, lazy, useState} from "react";
import {GlobalMessage} from "./internal/GlobalMessage";
import {useUserInformation} from "../../util/useUserInformation";
import {Menu} from "./internal/Menu";
import {createBoxVariantComponents, createMostlyFluidVariantComponents,} from "../../components/setup-factories";
import styled from "styled-components/macro";
import {Header} from "./internal/Header";
import {BoxPage} from "../../components/BoxPage";
import {useLocation} from 'react-router-dom'

// const AdminHeader = lazy(() =>
//   import("./internal/header-notification/NotificationAdmin").then(
//     (exports) => ({ default: exports.NotificationAdmin })
//   )
// );
const AudiologistHeader = lazy(() =>
    import("./internal/header-notification/NotificationAudiologist2").then(
        (exports) => ({
            default: exports.NotificationAudiologist,
        })
    )
);
// const WarehouseWorkerHeader = lazy(() =>
//   import("./internal/header-notification/NotificationWarehouseWorker").then(
//     (exports) => ({
//       default: exports.NotificationWarehouseWorker,
//     })
//   )
// );
const StockNotificationMixedHeader = lazy(() =>
    import("./internal/header-notification/StockNotificationMixed").then(
        (exports) => ({
            default: exports.StockNotificationMixed,
        })
    )
);
const StockNotificationWarehouseWorkerHeader = lazy(() =>
    import("./internal/header-notification/StockNotificationWarehouseWorker").then(
        (exports) => ({
            default: exports.StockNotificationWarehouseWorker,
        })
    )
);
const TransitNotificationMixedHeader = lazy(() =>
    import("./internal/header-notification/TransitNotificationMixed").then(
        (exports) => ({
            default: exports.TransitNotificationMixed,
        })
    )
);
const TransitNotificationWarehouseWorkerHeader = lazy(() =>
    import("./internal/header-notification/TransitNotificationWarehouseWorker").then(
        (exports) => ({
            default: exports.TransitNotificationWarehouseWorker,
        })
    )
);

const {MostlyFluidMenu} = createMostlyFluidVariantComponents({
    Menu: {
        widths: ["130px", "calc(100% - 130px)"],
        alignItems: "stretch",
        breakpoints: {medium: {widths: ["100%"]}, small: {widths: ["100%"]}},
    },
});

const {BoxContent} = createBoxVariantComponents({
    Content: {
        boxSizing: "border-box",
        width: {max: "calc(1500px + 2 * 16px)"}, // adjust for horizontal padding

        margin: {left: "auto", right: "auto"},
        padding: {
            top: "32px",
            right: "16px",
            // bottom: "400px",
            left: "16px",
        },
        flexGrow: 0,
        flexDirection: "column",
        justifyContent: "flex-start",
    },
});

/**
 * it would be ideal to use a mostly-fluid component here, but this is practially impossible due to the issue described here:
 * @see https://gitlab.com/webnuts/npm/browser/component-factories/-/issues/92
 */
const HeaderContainer = styled.div`
    > * {
        margin-bottom: 20px;
    }
`;

export const LayoutAuthorized: FC = memo(({children}) => {
    const {
        staffId,
        // hasAdminReadAccess,
        hasAudiologReadAccess,
        hasWarehouseWorkerReadAccess,
    } = useUserInformation();
    const [numberOfActiveNotificationsAudiologist, setNumberOfActiveNotificationsAudiologist] = useState(0);
    const [numberOfActiveNotificationsWarehouseWorker, setNumberOfActiveNotificationsWarehouseWorker] = useState(0);

    const location = useLocation();
    const pathsMaximumWidthPage = ["/warehouse-worker/audiologist-stock/overview", "/audiologist/stock/overview", "/mixed/customer-lists/overview", "/admin/time/overview", "/audiologist/order/create-order", "/audiologist/order/order-list", "/mixed/data/overview", "/audiologist/gps/kort", "/audiologist/gps/actions", "/mixed/stock-notifications/stock-notifications-list", "/warehouse-worker/stock2/overview", "/mixed/stock2/overview", "/mixed/stats/report", "/admin/stats/admin"];
    const pathsLargeWidthPage: string[] = [];
    const pathsMediumWidthPage = ["/admin/overtime/overview"];
    const pathsWithHeight = ["/audiologist/order/create-order", "/audiologist/order/order-list", "/audiologist/gps/kort", "/admin/contact-list"];
    const pathsWithoutAudiologistHeader = ["/audiologist/order/create-order", "/audiologist/order/order-list", "/all/calculator", "/audiologist/gps/kort", "/mixed/stats/report", "/admin/stats/admin"];
    const pathsWithoutAudiologistStockNotificationHeaders = ["/audiologist/order/create-order", "/audiologist/order/order-list", "/audiologist/gps/kort", "/mixed/stats/report", "/admin/stats/admin"];
    // const style = pathsMaximumWidthPage.includes(location.pathname)
    //     ? {padding: "5px", maxWidth: "100%"}
    //     : pathsMediumWidthPage.includes(location.pathname)
    //         ? {padding: "5px", maxWidth: "80%"}
    //         : {};
    let style = {};
    if (pathsMaximumWidthPage.includes(location.pathname))
        style = {...style, padding: "5px", maxWidth: "100%"};
    if (pathsLargeWidthPage.includes(location.pathname))
        style = {...style, padding: "5px", maxWidth: "90%"};
    if (pathsMediumWidthPage.includes(location.pathname))
        style = {...style, padding: "5px", maxWidth: "80%"};
    if (pathsWithHeight.includes(location.pathname))
        style = {...style, height: "100vh"};
    if (pathsWithoutAudiologistHeader.includes(location.pathname))
        style = {...style, padding: "0px"};

    return (
        <>
            <Header/>
            <BoxPage>
                <MostlyFluidMenu>
                    <Menu/>
                    <BoxContent style={{...style, minHeight: "100vh"}}>
                        <HeaderContainer>
                            {/*{(hasAdminReadAccess || hasWarehouseWorkerReadAccess) && <AdminHeader />}*/}
                            {!pathsWithoutAudiologistHeader.includes(location.pathname) &&
                                <>
                                    {hasAudiologReadAccess && <AudiologistHeader/>}
                                </>
                            }
                            {hasAudiologReadAccess && !pathsWithoutAudiologistStockNotificationHeaders.includes(location.pathname) &&
                                <div style={{
                                    display: "flex",
                                    flexDirection: numberOfActiveNotificationsAudiologist === 0 ? "row" : "column",
                                    gap: numberOfActiveNotificationsAudiologist === 0 ? "2px" : "0",
                                    margin: 0,
                                }}>
                                    <StockNotificationMixedHeader type="audiologist" setNumberOfActiveNotifications={setNumberOfActiveNotificationsAudiologist}/>
                                    <TransitNotificationMixedHeader type="audiologist" setNumberOfActiveNotifications={setNumberOfActiveNotificationsAudiologist}/>
                                </div>
                            }
                            {/*{hasWarehouseWorkerReadAccess && <WarehouseWorkerHeader />}*/}
                            {hasWarehouseWorkerReadAccess && ["019b98bc0cf70001330368545AE4EA12", "018e50e0cc2d0000c82d68545AE4EA12", "016b4d1b2e0b000126e328D24416C1E6"].includes(staffId) && // TOP, PAS & SL1
                                <div style={{
                                    display: "flex",
                                    flexDirection: numberOfActiveNotificationsWarehouseWorker === 0 ? "row" : "column",
                                    gap: numberOfActiveNotificationsWarehouseWorker === 0 ? "2px" : "0",
                                    margin: 0,
                                }}>
                                    <StockNotificationMixedHeader type="warehouse-worker" setNumberOfActiveNotifications={setNumberOfActiveNotificationsWarehouseWorker}/>
                                    <StockNotificationWarehouseWorkerHeader setNumberOfActiveNotifications={setNumberOfActiveNotificationsWarehouseWorker}/>
                                    <TransitNotificationMixedHeader type="warehouse-worker" setNumberOfActiveNotifications={setNumberOfActiveNotificationsWarehouseWorker}/>
                                    <TransitNotificationWarehouseWorkerHeader setNumberOfActiveNotifications={setNumberOfActiveNotificationsWarehouseWorker}/>
                                </div>
                            }
                            <GlobalMessage/>
                        </HeaderContainer>
                        {children}
                    </BoxContent>
                </MostlyFluidMenu>
            </BoxPage>
        </>
    );
});
